import { Send, BookOpen, Mail, ExternalLink, Code } from 'lucide-react'
import { useClipboard } from '@/hooks/useClipboard'

const links = [
  { icon: ExternalLink, url: 'https://twitter.com/metahubwallet', label: 'Twitter' },
  { icon: Send, url: 'https://t.me/MetaHub_Community', label: 'Telegram' },
  { icon: BookOpen, url: null, action: 'gitbook', label: 'Gitbook' },
  { icon: Code, url: 'https://github.com/metahubwallet/', label: 'GitHub' },
  { icon: Mail, url: null, action: 'email', label: 'Email' },
]

export function IconBox() {
  const { copy } = useClipboard()

  const handleClick = (item: (typeof links)[0]) => {
    if (item.url) {
      window.open(item.url)
    } else if (item.action === 'email') {
      copy('dev@metahub-ai.com')
    } else if (item.action === 'gitbook') {
      window.open('https://docs.infinitydao.fi/')
    }
  }

  return (
    <div className="flex items-center justify-center gap-3">
      {links.map((item, i) => (
        <button
          key={i}
          onClick={() => handleClick(item)}
          className="flex items-center bg-muted rounded-lg p-2 cursor-pointer transition-colors hover:bg-accent group"
          title={item.label}
        >
          <item.icon className="h-[15px] w-[15px] md:h-[18px] md:w-[18px] text-muted-foreground group-hover:text-primary transition-colors" />
        </button>
      ))}
    </div>
  )
}
